import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TableWithoutPagination from "../../Table/TableWithoutPagination";
import { Button, Checkbox, Icon, MenuItem } from "@material-ui/core";
import { ROLES } from "../../../redux/siteMonitoring/siteMonitoringConstants";
import {
	formatRole,
	setUsersAndRights,
	deleteUserAndRights,
} from "../../../redux/siteMonitoring/siteMonitoringActions";
import { clone } from "../../../utils";
import { throwErrorMessage } from "../../../lib/error_helper";
import SelectWithModal from "../../SelectWithModal/SelectWithModal";
import CustomizedSelect from "../../Input/CustomizedSelect";

class SettingsTab extends Component {
	constructor(props) {
		super(props);

		this.state = {
			tagRows: [],
			stateRows: [],
			usersRows: [],
			columns: [
				{
					Header: "Droits utilisateurs",
					columns: [
						{
							Header: "",
							id: "actions",
							width: 50,
							Cell: this.renderButtons.bind(this),
						},
						{
							Header: "Utilisateur",
							Cell: ({ index }) => {
								let usersAndRights = this.props.siteMonitoring.site_supervision_authorized_user_ids.filter(
									(u) => !u.deleted > 0
								);

								let currentUserAndRights = usersAndRights[index];

								if (!currentUserAndRights) return null;

								if (
									!this.props.siteMonitoring ||
									!this.props.siteMonitoring
										.site_supervision_authorized_user_ids
								)
									return null;

								let selectedUser = currentUserAndRights.user_id;

								return (
									<div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
										<SelectWithModal
											inputProps={{
												name: "user-" + index,
												id: "user-" + index,
											}}
											placeholder="Utilisateur"
											className="full_size"
											disabled={this.props.siteMonitoringDisabled}
											value={selectedUser ? {
												value: selectedUser.id,
												label: selectedUser.name
											} : ''}


											name={"user-" + index}
											id={"user-" + index}
											label={"Utilisateur"}
											onValidate={this.onUserChange.bind(this, index)}
											menuPlacement="auto"
											classNamePrefix="select"
											options={this.props.allUsers.map((u) => {
												return {
													value: u.id,
													label: u.name
												}
											})}
										/>

									</div >
								);
							},
						},
						{
							Header: "Droits",
							Cell: ({ index }) => {
								let usersAndRights = this.props.siteMonitoring.site_supervision_authorized_user_ids.filter(
									(u) => !u.deleted > 0
								);
								let currentUser = usersAndRights[index];

								if (
									!currentUser ||
									!this.props.siteMonitoring ||
									!this.props.siteMonitoring
										.site_supervision_authorized_user_ids ||
									!currentUser
								)
									return null;

								return (
									<div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
										<CustomizedSelect
											inputProps={{
												name: "rights-" + index,
												id: "rights-" + index,
											}}
											placeholder="Droits"
											className="full_size"
											onChange={this.onRightsChange.bind(this, index)}
											disabled={
												this.props.siteMonitoringDisabled ||
												!currentUser.user_id
											}
											value={currentUser.rights}
										>
											{ROLES.map((role) => {
												return (
													<MenuItem key={role} value={role}>
														{formatRole(role)}
													</MenuItem>
												);
											})}
										</CustomizedSelect>
									</div>
								);
							},
						},
						{
							Header: "Est employé",
							Cell: ({ index }) => {
								let usersAndRights = this.props.siteMonitoring.site_supervision_authorized_user_ids.filter(
									(u) => !u.deleted > 0
								);
								let currentUser = usersAndRights[index];

								if (
									!currentUser ||
									!this.props.siteMonitoring ||
									!this.props.siteMonitoring
										.site_supervision_authorized_user_ids ||
									!currentUser
								)
									return null;

								return (
									<div className="center col-lg-12 col-md-12 col-sm-12 col-12 row without-padding solution-table-row-padding">
										<Checkbox
											checked={currentUser.is_employee}
											className="small-checkbox light-disabled"
										/>
									</div>
								);
							},
						},
					],
				},
			],
		};
	}

	onUserChange(rowIndex, value) {
		let siteMonitoring = clone(this.props.siteMonitoring);
		let usersAndRights = [
			...siteMonitoring.site_supervision_authorized_user_ids,
		].filter((d) => !d.deleted);

		if (!usersAndRights[rowIndex]) return;

		let selectedUser = this.props.allUsers.find((u) => u.id === value.value);

		if (!selectedUser) return;

		let userAndRights = clone(usersAndRights[rowIndex]);
		userAndRights.user_id = selectedUser;

		if (
			userAndRights.user_id &&
			usersAndRights
				.filter((u) => u.user_id)
				.some((uar) => uar.user_id.id === userAndRights.user_id.id)
		) {
			this.props.throwErrorMessage({
				errorObject: siteMonitoring,
				title: "Erreur",
				message:
					"Impossible d'assigner plusieurs droits à un utilisateur pour une même affaire",
			});

			return;
		}

		usersAndRights[rowIndex] = userAndRights;
		siteMonitoring.site_supervision_authorized_user_ids = usersAndRights;
		this.props.setUsersAndRights(
			siteMonitoring,
			userAndRights,
			this.props.activeUser
		);
	}

	onRightsChange(rowIndex, e) {
		let siteMonitoring = clone(this.props.siteMonitoring);
		let usersAndRights = [
			...siteMonitoring.site_supervision_authorized_user_ids.filter(
				(d) => !d.deleted
			),
		];

		if (!usersAndRights[rowIndex]) return;

		usersAndRights[rowIndex].rights = e.target.value;
		siteMonitoring.site_supervision_authorized_user_ids = usersAndRights;
		this.props.setUsersAndRights(
			siteMonitoring,
			usersAndRights[rowIndex],
			this.props.activeUser
		);
	}

	renderButtons(row) {
		if (!row.original.user_id) return <div></div>;

		return (
			<div>
				<Button
					disabled={this.props.siteMonitoringDisabled}
					onClick={this.removeUser.bind(this, row)}
					className="col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin"
					color="primary"
				>
					<Icon className="small-icon">delete</Icon>
				</Button>
			</div>
		);
	}

	removeUser(elementToDelete) {
		let siteMonitoring = clone(this.props.siteMonitoring);
		let users = [
			...siteMonitoring.site_supervision_authorized_user_ids.filter(
				(d) => !d.deleted
			),
		];

		let indexOfUserToDelete = elementToDelete.row._index;

		if (indexOfUserToDelete !== undefined && indexOfUserToDelete >= 0) {
			users[indexOfUserToDelete].deleted = true;

			siteMonitoring.site_supervision_authorized_user_ids = users;
			this.props.deleteUserAndRights(
				siteMonitoring,
				users[indexOfUserToDelete],
				this.props.activeUser
			);
		}
	}

	getTableTrProps(state, rowInfo) {
		if (rowInfo && rowInfo.original.id === 0 && !rowInfo.original.deleted) {
			return {
				style: {
					background: "#E3F2FD",
				},
			};
		} else {
			return {};
		}
	}

	render() {
		return (
			<Card className="col-lg-12 col-md-12 col-sm-12 col-12 card card-margin-top without-side-padding">
				<CardContent className="without-side-padding">
					<TableWithoutPagination
						data={this.props.siteMonitoring.site_supervision_authorized_user_ids.filter(
							(u) => !u.deleted
						)}
						columns={this.state.columns}
						minRows={5}
						getTrProps={this.getTableTrProps.bind(this)}
						contentEditable
					/>
				</CardContent>
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
		activeUser: state.activeUser,
		allUsers: state.users.allUsers,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setUsersAndRights: (siteMonitoring, userAndRights, user) =>
			dispatch(setUsersAndRights(siteMonitoring, userAndRights, user)),
		deleteUserAndRights: (siteMonitoring, userAndRights, user) =>
			dispatch(deleteUserAndRights(siteMonitoring, userAndRights, user)),
		throwErrorMessage: (options) => dispatch(throwErrorMessage(options)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTab);
